<template>
  <div>
    <common ref="common" />
    <v-card class="rounded-xl" elevation="24" max-width="100%">
      <v-card-title> Announcements </v-card-title>
      <v-card-text>
        <v-carousel height="300" hide-delimiters class="events-carousel">
          <template v-if="eventsList.length">
            <template v-for="(event, eIndex) in eventsList">
              <v-carousel-item v-if="siteName && event.attachments.length" :key="eIndex">
                <img :src="siteName + event.attachments[0].storedUrl" />
              </v-carousel-item>
            </template>
          </template>
        </v-carousel>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { callApi } from "@/api/others";
import { returnURL } from "@/api/login.js";

export default {
  components: {
    common: () => import("@/components/tools/common.vue"),
  },
  data: () => ({
    eventsList: [],
    siteName: "",
  }),
  mounted() {
    this.getEvents();
    // console.log("process.env.VUE_APP_BASE_API", returnURL());
    this.siteName = returnURL();
  },
  methods: {
    getEvents() {
      let url = "/api/wesupport/Events/GetCurrentEvents";
      callApi(url, "get", "")
        .then((res) => {
          this.eventsList = res.data.data;
        })
        .catch((err) => {
          this.$refs.common.ManageResponse(err.response);
        });
    },
  },
};
</script>
<style>
.events-carousel img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.events-carousel .v-window__prev,
.v-window__next {
  margin: 0;
}
</style>
